import HTable from '@eduzz/houston-ui/Table';
import Typography from '@eduzz/houston-ui/Typography';
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';
import moment from 'moment';
import React, { useCallback } from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';
import Truncate from 'v2/components/Shared/TruncateText';
import { refundsService } from 'v2/services/reports/refunds';

import { useStyles } from './styles';

export const Table = () => {
  const classes = useStyles();

  useObservable(() => refundsService.loadRefunds(), []);
  const [refunds] = useObservable(() => refundsService.getRefunds(), []);
  const [isLoading] = useObservable(() => refundsService.isLoading(), []);
  const [pagination] = useObservable(() => refundsService.getPaginationResponse(), []);

  const onChangePerPage = useCallback(
    (per_page: number) => {
      refundsService.setPagination({ ...pagination, per_page, current_page: 1 });
      document.getElementById('refunds-table').scrollIntoView();
    },
    [pagination]
  );

  const onChangePage = useCallback(
    (page: number) => {
      refundsService.setPagination({ ...pagination, current_page: page });
      document.getElementById('refunds-table').scrollIntoView();
    },
    [pagination]
  );

  const PartialRefundTag = useCallback(
    () => (
      <Chip
        size='small'
        variant='outlined'
        label='Reembolso Parcial'
        deleteIcon={<Icon className={classes.customIcon}>money_off</Icon>}
        classes={{
          root: classes.chipRoot,
          label: classes.chipLabel,
          deleteIcon: classes.chipDeleteIcon,
        }}
        onDelete={() => ({})}
      />
    ),
    [classes.chipDeleteIcon, classes.chipLabel, classes.chipRoot, classes.customIcon]
  );

  return (
    <HTable id='refunds-table' data-testid='refunds-table' total={pagination?.total_items || 0} loading={isLoading}>
      <HTable.Header>
        <HTable.Column width={70}>Fatura</HTable.Column>
        <HTable.Column width={180}>Produto</HTable.Column>
        <HTable.Column width={100}>Pagamento em</HTable.Column>
        <HTable.Column width={100}>Reembolso em</HTable.Column>
        <HTable.Column width={110}>Dias Reembolso</HTable.Column>
        <HTable.Column width={220}>Motivo</HTable.Column>
        <HTable.Column width={100} align='right'>
          Valor da Venda
        </HTable.Column>
      </HTable.Header>
      <HTable.Body>
        {refunds?.map((refund, index) => (
          <>
            <HTable.Row key={`${refund.invoice_id}`} data={refund} index={index}>
              <HTable.Cell>
                <Typography size='xxs'>{refund?.invoice_id}</Typography>
              </HTable.Cell>
              <HTable.Cell>
                <>
                  <Typography size='xxs'>
                    <Truncate count={30} final='...'>
                      {refund?.product_name || '-'}
                    </Truncate>
                  </Typography>
                  <Typography size='xxs'>({refund?.product_id || '-'})</Typography>
                </>
              </HTable.Cell>
              <HTable.Cell>
                <Typography size='xxs'>{moment(refund?.received_at).format('DD/MM/YYYY')}</Typography>
                <Typography size='xxs'>{moment(refund?.received_at).format('HH:mm')}</Typography>
              </HTable.Cell>
              <HTable.Cell>
                <Typography size='xxs'>{moment(refund?.refunded_at).format('DD/MM/YYYY')}</Typography>
                <Typography size='xxs'>{moment(refund?.refunded_at).format('HH:mm')}</Typography>
              </HTable.Cell>
              <HTable.Cell>
                <Typography size='xxs'>{refund?.refund_days || 0}</Typography>
              </HTable.Cell>
              <HTable.Cell>
                <Typography size='xxs'>{refund?.motive || '-'}</Typography>
              </HTable.Cell>
              <HTable.Cell align='right'>
                <Typography weight='semibold'>
                  <FormattedNumber value={refund?.total_refunded || 0} format='BRL' />
                </Typography>
              </HTable.Cell>
            </HTable.Row>
            {refund?.partial_refund && (
              <HTable.Row className={classes.tagsRow} data={refund} index={index}>
                <HTable.Cell className={classes.tagsCell} colSpan={1000}>
                  <PartialRefundTag />
                </HTable.Cell>
              </HTable.Row>
            )}
          </>
        ))}
      </HTable.Body>
      {!isLoading && (
        <HTable.Pagination
          page={pagination?.current_page}
          perPage={pagination?.per_page}
          onChangePage={onChangePage}
          onChangePerPage={onChangePerPage}
          optionsPerPage='10,25,50'
        />
      )}
    </HTable>
  );
};
